"use client";

import { LDProvider } from "launchdarkly-react-client-sdk";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { ABContextProvider } from "./ABContextProvider";
import { MixpanelABProvider } from "./MixpanelABProvider";

type ABProviderProps = Partial<ComponentPropsWithoutRef<typeof LDProvider>> & {
  children: ReactNode;
};

export const ABProvider = ({ children, ...props }: ABProviderProps) => (
  <LDProvider
    clientSideID={process.env.NEXT_PUBLIC_LAUNCHDARKLY_KEY}
    reactOptions={{ useCamelCaseFlagKeys: false }}
    timeout={3}
    {...props}
  >
    <MixpanelABProvider>
      <ABContextProvider>{children}</ABContextProvider>
    </MixpanelABProvider>
  </LDProvider>
);
